const LOGIN_PATH = '/login';
const LOGIN_SSO_PATH = '/loginsso';
const FORGOT_PASSWORD_PATH = '/forgot-pass';
const RECOVER_PASSWORD_PATH = '/recover-pass';
const ACCOUNT_PATH = '/account';
const DUYET_ACCOUNT_PATH = '/duyet-account';
const TRA_CUU_CAN_BO_PATH = '/tra-cuu-can-bo';
const ACCOUNT_PATH_ADD = `${ACCOUNT_PATH}/add`;
const ACCOUNT_PATH_EDIT = `${ACCOUNT_PATH}/edit`;
const LOGIN_HISTORY_PATH = '/login-history';
const STATISTIC_HISTORY_PATH = '/statistic-login-history';

const EMAILCONFIG_PATH = '/emailconfig';
const EMAILCONFIG_CREATE_PATH = '/emailconfig/create';
const EMAILCONFIG_EDIT_PATH = '/emailconfig/edit';

const LOG_PATH = '/log';

const REPORT_POST_PATH = '/report-post';
const REPORT_POST_SYNTHETIC_PATH = '/report-post-synthentic';
const REPORT_POST_EXCEL_PATH = '/report-post-excel';
const REPORT_POST_EXCEL_QUANTITY_CREATE_BY =
    '/report-post-excel-quantity-createby';
const REPORT_POST_EXCEL_CREATE_BY = '/report-post-excel-createby';

const REPORT_POST_WEBANALYSIS_PATH = '/report-post-web-analysis';
const REPORT_POST_BY_DATETYPE = '/report-post-by-datetype';
const REPORT_POST_VIEW_DETAIL = '/report-post-view-detail';
const REPORT_POST_PUBLISHTIME_DATATYPE_PATH =
    '/report-post-publish-time-data-type';
const REPORT_ADVERTISING_ANALYSIS_PATH = '/advertising-analysis';
const REPORT_COUNT_VISIT_DETAIL = '/report-count-visit-detail';

const DONVIDENGHI_PATH = '/don-vi-de-nghi';
const DONVIDENGHI_CREATE_PATH = `${DONVIDENGHI_PATH}/them`;
const DONVIDENGHI_EDIT_PATH = `${DONVIDENGHI_PATH}/sua`;

const APIROLEMAPPING_PATH = '/api-role-mapping';
const APIROLEMAPPING_CREATE_PATH = `${APIROLEMAPPING_PATH}/them`;
const APIROLEMAPPING_EDIT_PATH = `${APIROLEMAPPING_PATH}/sua`;

const OPENIDDICTAPPLICATION_PATH = '/ung-dung-dang-ky';
const OPENIDDICTAPPLICATION_CREATE_PATH = `${OPENIDDICTAPPLICATION_PATH}/them`;
const OPENIDDICTAPPLICATION_EDIT_PATH = `${OPENIDDICTAPPLICATION_PATH}/sua`;

const MENUITEM_PATH = '/menu';
const MENUITEM_CREATE_PATH = `${MENUITEM_PATH}/them`;
const MENUITEM_EDIT_PATH = `${MENUITEM_PATH}/sua`;

const BAOCAO_PATH = '/bao-cao';

const ROLE_ACCOUNT_PATH = '/role-account';
const ROLE_ACCOUNT_CREATE_PATH = '/role-account/create';
const ROLE_ACCOUNT_EDIT_PATH = '/role-account/edit';

const KYSO_PATH = '/ky-so';

const SIGNED_HUMAN_PATH = '/nguoi-duoc-ky';
const SIGNED_HUMAN_CREATE_PATH = '/nguoi-duoc-ky/create';
const SIGNED_HUMAN_EDIT_PATH = '/nguoi-duoc-ky/edit';

// Common
const CHUDE_PATH = '/chu-de';
const CHUDE_CREATE_PATH = '/chu-de/create';
const CHUDE_EDIT_PATH = '/chu-de/edit';

const HOADONTHANHTOAN_PATH = '/hoa-don-thanh-toan';
const HOADONTHANHTOAN_CREATE_PATH = '/hoa-don-thanh-toan/create';
const HOADONTHANHTOAN_EDIT_PATH = '/hoa-don-thanh-toan/edit';

const DANHMUCPHANMEM_PATH = '/danh-muc-phan-mem';
const DANHMUCPHANMEM_SHOW_PATH = '/danh-muc-phan-mem-chon';
const DANHMUCPHANMEM_CREATE_PATH = '/danh-muc-phan-mem/create';
const DANHMUCPHANMEM_EDIT_PATH = '/danh-muc-phan-mem/edit';

const CHUONGTRINHHOC_PATH = '/chuong-trinh-hoc';
const CHUONGTRINHHOC_CREATE_PATH = '/chuong-trinh-hoc/create';
const CHUONGTRINHHOC_EDIT_PATH = '/chuong-trinh-hoc/edit';

const NGANH_PATH = '/nganh';
const NGANH_CREATE_PATH = '/nganh/create';
const NGANH_EDIT_PATH = '/nganh/edit';

const NHOMTIEUCHI_PATH = '/nhom-tieu-chi';
const NHOMTIEUCHI_CREATE_PATH = '/nhom-tieu-chi/create';
const NHOMTIEUCHI_EDIT_PATH = '/nhom-tieu-chi/edit';

const TIEUCHI_PATH = '/quan-ly-tuyen-sinh/tieu-chi';
const TIEUCHI_CREATE_PATH = '/quan-ly-tuyen-sinh/tieu-chi-them-moi';
const TIEUCHI_EDIT_PATH = '/quan-ly-tuyen-sinh/tieu-chi-cap-nhat';

const MUCDANHGIA_PATH = '/quan-ly-tuyen-sinh/muc-danh-gia';
const MUCDANHGIA_CREATE_PATH = '/quan-ly-tuyen-sinh/muc-danh-gia-them-moi';
const MUCDANHGIA_EDIT_PATH = '/quan-ly-tuyen-sinh/muc-danh-gia-cap-nhat';

const CHUYENNGANH_PATH = '/chuyen-nganh';
const CHUYENNGANH_CREATE_PATH = '/chuyen-nganh/create';
const CHUYENNGANH_EDIT_PATH = '/chuyen-nganh/edit';

const DANHMUCVANBANGCHUNGCHI_PATH = '/danh-muc-van-bang-chung-chi';
const DANHMUCVANBANGCHUNGCHI_CREATE_PATH = '/danh-muc-van-bang-chung-chi/create';
const DANHMUCVANBANGCHUNGCHI_EDIT_PATH = '/danh-muc-van-bang-chung-chi/edit';

// QuyTrinhTuyenSinh
////////////
// CapNhatKienThucYKhoa (CME)
const CMECONFIG_PATH = '/cme/config';
const CMEDICTIONARY_PATH = '/cme/dictionary';
const CMEDUYETHOSO_PATH = '/cme/duyet-ho-so';
const CMECA_NHAN_PATH = '/cme/ca-nhan';
const CMECA_NHAN_CREATE_PATH = `${CMECA_NHAN_PATH}/create`;
const CMECA_NHAN_EDIT_PATH = `${CMECA_NHAN_PATH}/edit`;
const CMEDASHBOARD_PATH = '/cme/dashboard';
const CMEEVENT_PATH = '/cme/event';
const CMEDIEUDUONG_EVENT_PATH = '/cme-dieu-duong/event';
const CMEDIEUDUONG_ATTENDANCE_PATH = '/cme-dieu-duong/attendance';
const CMEDIEUDUONG_DUYET_PATH = '/cme-dieu-duong/duyet';
const PHAMVIHANHNGHE_PATH = '/pham-vi-hanh-nghe';
const PHAMVIHANHNGHE_CREATE_PATH = '/pham-vi-hanh-nghe/create';
const PHAMVIHANHNGHE_EDIT_PATH = '/pham-vi-hanh-nghe/edit';

const GIAYPHEPHANHNGHE_PATH = '/giay-phep-hanh-nghe';
const GIAYPHEPHANHNGHE_CREATE_PATH = '/giay-phep-hanh-nghe/create';
const GIAYPHEPHANHNGHE_EDIT_PATH = '/giay-phep-hanh-nghe/edit';

const VANBANG_PATH = '/van-bang';
const VANBANG_CREATE_PATH = '/van-bang/create';
const VANBANG_EDIT_PATH = '/van-bang/edit';

const CHUNGCHINGOAINGU_PATH = '/chung-chi-ngoai-ngu';
const CHUNGCHINGOAINGU_CREATE_PATH = '/chung-chi-ngoai-ngu/create';
const CHUNGCHINGOAINGU_EDIT_PATH = '/chung-chi-ngoai-ngu/edit';

const THONGKEDUYET_PATH = '/thong-ke-duyet';

const DANHSACHDUYETHOSO_PATH = '/danh-sach-duyet-ho-so';

const BIEUMAUTUYENSINH_PATH = '/quan-ly-tuyen-sinh/bieu-mau-tuyen-sinh';
const DOTTUYENSINH_PATH = '/quan-ly-tuyen-sinh/dot-tuyen-sinh';
const DOTTUYENSINH_CREATE_PATH = '/quan-ly-tuyen-sinh/dot-tuyen-sinh/create';
const DOTTUYENSINH_EDIT_PATH = '/quan-ly-tuyen-sinh/dot-tuyen-sinh/edit';

const LOPDAOTAOLIENTUC_PATH = '/quan-ly-tuyen-sinh/lop-dao-tao-lien-tuc';
const LOPDAOTAOLIENTUC_CREATE_PATH = '/quan-ly-tuyen-sinh/lop-dao-tao-lien-tuc/create';
const LOPDAOTAOLIENTUC_EDIT_PATH = '/quan-ly-tuyen-sinh/lop-dao-tao-lien-tuc/edit';

const LOPDAOTAOTHUCHANH_PATH = '/quan-ly-tuyen-sinh/lop-dao-tao-thuc-hanh';
const LOPDAOTAOTHUCHANH_CREATE_PATH = '/quan-ly-tuyen-sinh/lop-dao-tao-thuc-hanh/create';
const LOPDAOTAOTHUCHANH_EDIT_PATH = '/quan-ly-tuyen-sinh/lop-dao-tao-thuc-hanh/edit';
const DANGKY_DOTTUYENSINH_PATH = '/dang-ky-tuyen-sinh/dot-tuyen-sinh';
const HOSOTUYENSINH_PATH = '/quan-ly-tuyen-sinh/ho-so-tuyen-sinh';
const DAOTAOTHUCHANH_PATH = '/dao-tao-thuc-hanh';
const BIEUMAUTIENSI_PATH = '/dao-tao-tien-si/bieu-mau-tien-si';
const LUUTRUHOSOTIENSI_PATH = '/dao-tao-tien-si/luu-tru-ho-so';
const HOSO_NGHIENCUUSINH_PATH = '/dao-tao-tien-si/ho-so-nghien-cuu-sinh';
const GIAIDOAN_DAOTAO_NCS_PATH = '/dao-tao-tien-si/ho-so-nghien-cuu-sinh/giai-doan-dao-tao/:id';
const YEUCAU_THAYDOI_NCS_PATH = '/dao-tao-tien-si/ho-so-nghien-cuu-sinh/yeu-cau-thay-doi/:id';
const QUANLY_HOSO_NCS_PATH = '/dao-tao-tien-si/quan-ly-ho-so-ncs';
const QUANLY_GIAIDOAN_DAOTAO_NCS_PATH = '/dao-tao-tien-si/quan-ly-ho-so-ncs/giai-doan-dao-tao/:id';
const NGANHDAOTAO_PATH = '/nganh-dao-tao';
const CHUONGTRINHDAOTAO_PATH = '/chuong-trinh-dao-tao';
const HOPDONGDAOTAO_PATH = '/hop-dong-dao-tao';
const KHOADAOTAO_PATH = '/khoa-dao-tao';
const KHOADAOTAO_DETAIL_PATH = '/khoa-dao-tao/detail/:id';
const DUYET_HOSOTUYENSINH_PATH = '/quan-ly-tuyen-sinh/duyet-ho-so-tuyen-sinh';

const TRIENKHAI_DAOTAOLIENTUC_PATH = '/trien-khai-dao-tao-lien-tuc/lop-hoc';
const TRIENKHAI_DAOTAOLIENTUC_GV_PATH = '/trien-khai-dao-tao-lien-tuc/lop-hoc-gv';
const TRIENKHAI_DAOTAOLIENTUC_GV_DETAIL_PATH = '/trien-khai-dao-tao-lien-tuc/lop-hoc-gv/:id';
const TRIENKHAI_DAOTAOLIENTUC_HV_PATH = '/trien-khai-dao-tao-lien-tuc/lop-hoc-hv';
const TRIENKHAI_DAOTAOLIENTUC_HV_DETAIL_PATH = '/trien-khai-dao-tao-lien-tuc/lop-hoc-hv/:id';
const TRIENKHAI_DAOTAOLIENTUC_DETAIL_PATH = '/trien-khai-dao-tao-lien-tuc/lop-hoc/:id';

const TRIENKHAI_HUONGDANTHUCHANH_PATH = '/trien-khai-huong-dan-thuc-hanh/lop-hoc';
const TRIENKHAI_HUONGDANTHUCHANH_DETAIL_PATH = '/trien-khai-huong-dan-thuc-hanh/lop-hoc/:id';
const TRIENKHAI_HUONGDANTHUCHANH_GV_PATH = '/trien-khai-huong-dan-thuc-hanh/lop-hoc-gv';
const TRIENKHAI_HUONGDANTHUCHANH_GV_DETAIL_PATH = '/trien-khai-huong-dan-thuc-hanh/lop-hoc-gv/:id';
const TRIENKHAI_HUONGDANTHUCHANH_HV_PATH = '/trien-khai-huong-dan-thuc-hanh/lop-hoc-hv';
const TRIENKHAI_HUONGDANTHUCHANH_HV_DETAIL_PATH = '/trien-khai-huong-dan-thuc-hanh/lop-hoc-hv/:id';

export const URI_INTERNAL = {
    BIEUMAUTIENSI_PATH,
    LUUTRUHOSOTIENSI_PATH,
    HOSO_NGHIENCUUSINH_PATH,
    GIAIDOAN_DAOTAO_NCS_PATH,
    YEUCAU_THAYDOI_NCS_PATH,
    QUANLY_HOSO_NCS_PATH,
    QUANLY_GIAIDOAN_DAOTAO_NCS_PATH,
    DAOTAOTHUCHANH_PATH,
    NGANHDAOTAO_PATH,
    CHUONGTRINHDAOTAO_PATH,
    HOPDONGDAOTAO_PATH,
    KHOADAOTAO_PATH,
    KHOADAOTAO_DETAIL_PATH,
    REPORT_ADVERTISING_ANALYSIS_PATH,
    REPORT_POST_VIEW_DETAIL,
    REPORT_POST_BY_DATETYPE,
    REPORT_POST_EXCEL_CREATE_BY,
    REPORT_POST_EXCEL_QUANTITY_CREATE_BY,
    REPORT_POST_SYNTHETIC_PATH,
    REPORT_POST_PATH,
    RECOVER_PASSWORD_PATH,
    FORGOT_PASSWORD_PATH,
    ACCOUNT_PATH_EDIT,
    ACCOUNT_PATH_ADD,
    LOGIN_PATH,
    LOGIN_SSO_PATH,
    ACCOUNT_PATH,
    DUYET_ACCOUNT_PATH,
    TRA_CUU_CAN_BO_PATH,
    LOGIN_HISTORY_PATH,
    EMAILCONFIG_PATH,
    EMAILCONFIG_CREATE_PATH,
    EMAILCONFIG_EDIT_PATH,
    STATISTIC_HISTORY_PATH,
    LOG_PATH,
    REPORT_POST_EXCEL_PATH,
    REPORT_POST_WEBANALYSIS_PATH,
    REPORT_POST_PUBLISHTIME_DATATYPE_PATH,
    REPORT_COUNT_VISIT_DETAIL,

    DONVIDENGHI_PATH,
    DONVIDENGHI_CREATE_PATH,
    DONVIDENGHI_EDIT_PATH,

    APIROLEMAPPING_PATH,
    APIROLEMAPPING_CREATE_PATH,
    APIROLEMAPPING_EDIT_PATH,

    OPENIDDICTAPPLICATION_PATH,
    OPENIDDICTAPPLICATION_CREATE_PATH,
    OPENIDDICTAPPLICATION_EDIT_PATH,

    MENUITEM_PATH,
    MENUITEM_CREATE_PATH,
    MENUITEM_EDIT_PATH,

    ROLE_ACCOUNT_PATH,
    ROLE_ACCOUNT_CREATE_PATH,
    ROLE_ACCOUNT_EDIT_PATH,

    BAOCAO_PATH,

    KYSO_PATH,

    SIGNED_HUMAN_PATH,
    SIGNED_HUMAN_CREATE_PATH,
    SIGNED_HUMAN_EDIT_PATH,

    // Common
    CHUDE_PATH,
    CHUDE_CREATE_PATH,
    CHUDE_EDIT_PATH,

    HOADONTHANHTOAN_PATH,
    HOADONTHANHTOAN_CREATE_PATH,
    HOADONTHANHTOAN_EDIT_PATH,

    DANHMUCPHANMEM_PATH,
    DANHMUCPHANMEM_SHOW_PATH,
    DANHMUCPHANMEM_CREATE_PATH,
    DANHMUCPHANMEM_EDIT_PATH,

    CHUONGTRINHHOC_PATH,
    CHUONGTRINHHOC_CREATE_PATH,
    CHUONGTRINHHOC_EDIT_PATH,

    NGANH_PATH,
    NGANH_CREATE_PATH,
    NGANH_EDIT_PATH,

    NHOMTIEUCHI_PATH,
    NHOMTIEUCHI_CREATE_PATH,
    NHOMTIEUCHI_EDIT_PATH,
    TIEUCHI_PATH,
    TIEUCHI_CREATE_PATH,
    TIEUCHI_EDIT_PATH,

    MUCDANHGIA_PATH,
    MUCDANHGIA_CREATE_PATH,
    MUCDANHGIA_EDIT_PATH,

    CHUYENNGANH_PATH,
    CHUYENNGANH_CREATE_PATH,
    CHUYENNGANH_EDIT_PATH,

    DANHMUCVANBANGCHUNGCHI_PATH,
    DANHMUCVANBANGCHUNGCHI_CREATE_PATH,
    DANHMUCVANBANGCHUNGCHI_EDIT_PATH,

    // QuyTrinhTuyenSinh
    ////////////
    // CapNhatKienThucYKhoa (CME)
    CMECONFIG_PATH,
    CMEDICTIONARY_PATH,
    CMEDUYETHOSO_PATH,
    CMECA_NHAN_PATH,
    CMECA_NHAN_CREATE_PATH,
    CMECA_NHAN_EDIT_PATH,
    CMEDASHBOARD_PATH,
    CMEEVENT_PATH,
    CMEDIEUDUONG_EVENT_PATH,
    CMEDIEUDUONG_ATTENDANCE_PATH,
    CMEDIEUDUONG_DUYET_PATH,
    PHAMVIHANHNGHE_PATH,
    PHAMVIHANHNGHE_CREATE_PATH,
    PHAMVIHANHNGHE_EDIT_PATH,

    GIAYPHEPHANHNGHE_PATH,
    GIAYPHEPHANHNGHE_CREATE_PATH,
    GIAYPHEPHANHNGHE_EDIT_PATH,
    VANBANG_PATH,
    VANBANG_CREATE_PATH,
    VANBANG_EDIT_PATH,
    CHUNGCHINGOAINGU_PATH,
    CHUNGCHINGOAINGU_CREATE_PATH,
    CHUNGCHINGOAINGU_EDIT_PATH,
    DANHSACHDUYETHOSO_PATH,
    THONGKEDUYET_PATH,
    BIEUMAUTUYENSINH_PATH,
    DOTTUYENSINH_PATH,
    DOTTUYENSINH_CREATE_PATH,
    DOTTUYENSINH_EDIT_PATH,
    LOPDAOTAOLIENTUC_PATH,
    LOPDAOTAOLIENTUC_CREATE_PATH,
    LOPDAOTAOLIENTUC_EDIT_PATH,
    LOPDAOTAOTHUCHANH_PATH,
    LOPDAOTAOTHUCHANH_CREATE_PATH,
    LOPDAOTAOTHUCHANH_EDIT_PATH,
    DANGKY_DOTTUYENSINH_PATH,
    HOSOTUYENSINH_PATH,
    DUYET_HOSOTUYENSINH_PATH,
    TRIENKHAI_DAOTAOLIENTUC_PATH,
    TRIENKHAI_DAOTAOLIENTUC_GV_PATH,
    TRIENKHAI_DAOTAOLIENTUC_GV_DETAIL_PATH,
    TRIENKHAI_DAOTAOLIENTUC_HV_PATH,
    TRIENKHAI_DAOTAOLIENTUC_HV_DETAIL_PATH,
    TRIENKHAI_DAOTAOLIENTUC_DETAIL_PATH,
    TRIENKHAI_HUONGDANTHUCHANH_PATH,
    TRIENKHAI_HUONGDANTHUCHANH_DETAIL_PATH,
    TRIENKHAI_HUONGDANTHUCHANH_GV_PATH,
    TRIENKHAI_HUONGDANTHUCHANH_GV_DETAIL_PATH,
    TRIENKHAI_HUONGDANTHUCHANH_HV_PATH,
    TRIENKHAI_HUONGDANTHUCHANH_HV_DETAIL_PATH
};
